import { NAVIGATION_MENU_MAP } from '../constants';
import { setCredentials } from '../features/authSlice';
import { apiSlice } from '../services/api';
import { mainApiSlice } from '../services/main';
import { store } from '../services/store';
import { ResponseBody } from '../types/common';

import {
  getAccessToken,
  getRefreshToken,
  getTokens,
  setToken,
} from './storage';
import { VITE_URL, VITE_CREATOR_URL, VITE_VIEWER_URL } from './util';

const getForm = (
  target: string,
  action: string,
  value: string,
  page?: string
) => {
  const form = document.createElement('form');

  const addInput = (name: string, value: string) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  form.target = target;
  form.method = 'POST';
  form.action = action;
  form.style.display = 'none';

  addInput('bookId', value);
  addInput('pathname', window.location.href.split(VITE_URL)[1]);
  addInput('accessToken', getAccessToken()!);
  addInput('refreshToken', getRefreshToken()!);
  page && addInput('page', page);

  document.body.appendChild(form);

  return form;
};

const setRefreshToken = async () => {
  try {
    const res: ResponseBody = await store
      .dispatch(apiSlice.endpoints.refreshToken.initiate(getTokens()))
      .unwrap();
    if (res.data) {
      store.dispatch(setCredentials({ ...res.data }));
      setToken({ ...res.data });
    }
  } catch (error) {
    console.error('Failed to get refresh token');
  }
};

const updateHistory = async (projectId: number, name: string = '') => {
  const menuName = store.getState().info.menu;
  const menuList = store.getState().main.menuList;
  const menu = menuList.find(
    ({ nm }) => nm === NAVIGATION_MENU_MAP[name ? name : menuName]
  );

  try {
    await store
      .dispatch(
        mainApiSlice.endpoints.addViewerHistory.initiate({
          projectId,
          cd: menu?.cd ?? '',
        })
      )
      .unwrap();
  } catch (error) {
    console.error('Failed to post viewer history', error);
  }
};

export const openSelpubCloud = async (
  service: 'viewer' | 'creator',
  projectId: number,
  isCurContext?: boolean,
  page?: string,
  isGuest?: boolean,
  name?: string
) => {
  !isGuest && (await setRefreshToken());

  const isViewer = service === 'viewer';
  const target = isCurContext ? '_self' : `selpub_${service}`;
  const url = isViewer ? VITE_VIEWER_URL : VITE_CREATOR_URL;
  const value = projectId.toString();
  const form = getForm(target, url, value, page);

  window.open('', target);
  form.submit();
  document.body.removeChild(form);

  if (isViewer) {
    updateHistory(projectId, name);
  }
};
